import { useRouter } from 'next/router';
import { useTheme } from 'pages/superadmin/ThemeContext';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { PageUrls } from '../../../project/page-urls';

const AnonymousAssessmentPage = () => {
  const router = useRouter();
  const { anonymousId } = router.query;
  const { themeColors, themeIcons } = useTheme();

  useEffect(() => {
    if (typeof anonymousId === 'string') {
      sessionStorage.setItem('anonymousUrlId', anonymousId);
    }
  }, [anonymousId]);

  const [templateIntroduction, setTemplateIntroduction] = useState();
  const [projectId, setProjectId] = useState('');
  const [anonymousAssessmentId, setAnonymousAssessmentId] = useState('');
  const [currentPath, setCurrentPath] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  const handleInputChange = (e) => {
    setAnonymousAssessmentId(e.target.value);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      fetchAnonymousAssessment();
    }
  }, []);

  const fetchAnonymousAssessment = async () => {
    try {
      {
        const response = await axios.get(
          `${Project.api}assessments/anonymousAssessmentUrl/${anonymousId}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        if (response && response.data) {
          setTemplateIntroduction(response.data.templateIntroduction);
          setProjectId(response.data.id);
          setLogoUrl(response.data.logoUrl);
          if (response.data.templateStatus !== 'PUBLISHED') {
            router.push(`/anonymous-assessments/${anonymousId}/error`);
          }
        }
      }
    } catch (error) {
      console.error('Error updating data:', error);
      router.push(`/anonymous-assessments/${anonymousId}/error`);
    }
  };

  const handleStartAssessmentBtn = () => {
    const previousPath = sessionStorage.getItem('previousPath');
    const url = new URL(previousPath, window.location.origin);
    const cleanPathname = url.pathname;

    if (currentPath.includes('instructions')) {
      router.push({
        pathname: cleanPathname,
        query: { anonymousId: anonymousId },
      });
    } else {
      const handleAnonymousAssessment = async () => {
        try {
          {
            const response = await axios.post(
              `${Project.api}anonymousAssessments`,
              JSON.stringify({
                'anonymousUrlId': anonymousId,
              }),
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              },
            );
            if (response && response.data) {
              router.push({
                pathname: PageUrls.anonymous_assessment(
                  response.data.projectId,
                  response.data.id,
                ),
                query: { anonymousId: anonymousId },
              });
            }
          }
        } catch (error) {
          console.error('Error updating data:', error);
          router.push(`/anonymous-assessments/${anonymousId}/error`);
        }
      };
      handleAnonymousAssessment();
    }
  };

  const handleContinueAssessment = () => {
    const fetchAnonymousAssessment = async () => {
      try {
        {
          const response = await axios.get(
            `${Project.api}anonymousAssessments/${anonymousAssessmentId}`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );
          if (response && response.data) {
            if (response.data.status == 'COMPLETE') {
              router.push({
                pathname: PageUrls.anonymous_report(
                  projectId,
                  anonymousAssessmentId,
                ),
              });
            } else {
              router.push({
                pathname: PageUrls.anonymous_assessment(
                  projectId,
                  anonymousAssessmentId,
                ),
              });
            }
          }
        }
      } catch (error) {
        console.error('Error updating data:', error);
        router.push(`/anonymous-assessments/${anonymousId}/error`);
      }
    };
    fetchAnonymousAssessment();
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentPath(router.asPath);
    }
  }, [router]);

  return (
    <>
      <style jsx>{`
        /* Hide scrollbar but keep functionality */
        .introduction-content::-webkit-scrollbar {
          display: none;
        }
        .introduction-content {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .introduction-widget {
          padding: 30px;
        }

        .introduction-content {
          line-height: 1.6;
        }

        .introduction-content p {
          margin-bottom: 1rem;
        }

        .introduction-content h1,
        .introduction-content h2,
        .introduction-content h3,
        .introduction-content h4,
        .introduction-content h5,
        .introduction-content h6 {
          margin-top: 1.5rem;
          margin-bottom: 1rem;
          font-weight: 600;
        }

        .introduction-content h1:first-child,
        .introduction-content h2:first-child,
        .introduction-content h3:first-child,
        .introduction-content h4:first-child,
        .introduction-content h5:first-child,
        .introduction-content h6:first-child,
        .introduction-content p:first-child {
          margin-top: 0;
        }

        .introduction-content ul,
        .introduction-content ol {
          margin-bottom: 1rem;
          padding-left: 1.5rem;
        }

        .introduction-content li {
          margin-bottom: 0.5rem;
        }

        @media (max-width: 768px) {
          .hide-on-mobile {
            display: none !important;
          }
          .logo-mobile-size {
            width: 150px !important;
          }
          .mobile-logo-container {
            margin-top: 20px !important;
          }
          .mobile-logo-spacing {
            margin-bottom: 15px !important;
            padding-bottom: 0 !important;
          }
          .mobile-logo-spacing-bottom {
            margin-top: 15px !important;
            margin-bottom: 20px !important;
            padding-bottom: 0 !important;
          }
          .mobile-content-wrapper {
            flex-direction: column !important;
          }
          .mobile-left-panel {
            height: auto !important;
            padding: 20px 0 10px 0 !important;
          }
          .mobile-right-panel {
            height: auto !important;
            padding: 10px 15px 30px 15px !important;
          }
          .mobile-widget {
            width: 100% !important;
            max-width: 100% !important;
            padding: 15px !important;
          }
          .introduction-widget {
            padding: 20px !important;
          }
        }

        @media (min-width: 769px) {
          .mobile-widget {
            width: 100% !important;
            max-width: 600px !important;
          }
        }
      `}</style>

      <div className='container-fluid'>
        <div
          className='row mobile-content-wrapper'
          style={{ minHeight: '100vh' }}
        >
          <div className='col-md-6 d-flex align-items-center justify-content-center h-100 mobile-left-panel'>
            <div
              className='mobile-logo-container'
              style={{ marginTop: '100px' }}
            >
              <div className='mb-5 pb-4 mobile-logo-spacing'>
                <img
                  src={logoUrl}
                  className='img-fluid mx-auto d-block logo-mobile-size'
                  style={{ width: '300px', height: 'auto', maxHeight: '220px' }}
                  alt='Logo'
                />
              </div>
              <div className='hide-on-mobile'>
                <img
                  src='/images/anonymous-intro.png'
                  className='img-fluid mx-auto d-block'
                  style={{ width: '300px', height: 'auto' }}
                />
              </div>
              <div className='mt-5 pb-4 mobile-logo-spacing-bottom'>
                <img
                  src={themeIcons.loginLogoFileName}
                  className='img-fluid mx-auto d-block logo-mobile-size'
                  style={{ width: '300px', height: 'auto' }}
                  alt='Logo'
                />
              </div>
            </div>
          </div>
          <div
            className='col-md-6 d-flex align-items-center justify-content-center mobile-right-panel'
            style={{
              minHeight: '100vh',
              backgroundColor: '#fff',
              display: 'flex',
            }}
          >
            <div
              className='introduction-widget mobile-widget'
              style={{
                width: '80%',
                maxWidth: '500px',
                backgroundColor: 'white',
                borderRadius: '10px',
                textAlign: 'left',
              }}
            >
              <div
                className='introduction-content'
                style={{
                  maxHeight: '400px',
                  overflowY: 'auto',
                  marginBottom: '25px',
                }}
              >
                {templateIntroduction &&
                templateIntroduction.replace(/<[^>]+>/g, '').trim() !== '' ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: templateIntroduction }}
                  />
                ) : (
                  <p>No instructions available at this time.</p>
                )}
              </div>

              <button
                className='btn btn-primary w-100'
                onClick={() => handleStartAssessmentBtn()}
              >
                {currentPath.includes('instructions')
                  ? 'Continue Assessment'
                  : 'Start Assessment'}
              </button>

              {!currentPath.includes('instructions') && (
                <>
                  <div className='col-md-12' style={{ marginTop: '20px', marginBottom: '10px' }}>
                    <h5 style={{ textAlign: 'center', margin: '0' }}>
                      <span>OR</span>
                    </h5>
                  </div>

                  <div className='col-md-12'>
                    <div className='input-container'>
                      <div className='row'>
                        <div
                          style={{
                            marginBottom: '7px',
                            marginLeft: '18px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                          }}
                        >
                          <label htmlFor='projectName'>Assessment ID</label>
                        </div>
                      </div>
                      <input
                        name='assessmentId'
                        className='input'
                        value={anonymousAssessmentId}
                        onChange={handleInputChange}
                      />
                    </div>
                    <button
                      className='btn btn-primary w-100 mt-4'
                      disabled={!anonymousAssessmentId.trim()}
                      onClick={() => handleContinueAssessment()}
                    >
                      Continue Assessment
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnonymousAssessmentPage;